<template>
  <v-container>
    <v-card-text>
      <p class="account-text-header">Юр. Информация</p>
      <v-text-field
        v-model="company.name"
        outlined
        required
        label="* Юр. лицо"
        :rules="nonEmptyRules"
      >
      </v-text-field>
      <v-select
        v-model="company.country"
        :rules="nonEmptyRules"
        item-text="state"
        item-value="abbr"
        :items="countries"
        outlined
        required
        persistent-hint
        single-line
        prepend-inner-icon="mdi-earth"
        label="* Страна"
      >
      </v-select>
      <v-text-field
        v-model="company.city"
        outlined
        :rules="nonEmptyRules"
        required
        label="* Город"
      >
      </v-text-field>
      <v-text-field
        v-model="company.address"
        outlined
        :rules="nonEmptyRules"
        label="* Адрес"
        required
      >
      </v-text-field>
      <v-text-field
        v-model="company.ogrnip"
        outlined
        :rules="ogrnRules"
        required
        label="* ОГРН"
      >
      </v-text-field>
      <v-text-field
        v-model="company.inn"
        outlined
        :rules="innRules"
        required
        label="* ИНН"
      >
      </v-text-field>
      <v-text-field
        v-model="company.contract_number"
        outlined
        label="Номер договора"
      />
      <p class="account-text-header">Банковские данные</p>
      <v-text-field
        v-model="company.bank_account"
        outlined
        label="Банковский счет"
      />
      <v-text-field
        v-model="company.bank_name"
        outlined
        label="Банк"
      />
      <v-text-field
        v-model="company.bank_bik"
        outlined
        :rules="bikRules"
        maxlength="9"
        label="БИК"
      />
      <v-text-field
        v-model="company.bank_inn"
        outlined
        :rules="bankInnRules"
        label="ИНН банка"
      />
      <v-btn
        text
        outlined
        color="dark"
        @click="saveAccountCompany"
      >
        Сохранить
      </v-btn>
    </v-card-text>
  </v-container>
</template>

<script>
import account from "@/api/account";

export default {
  name: "CompanyForm",
  data() {
    return {
      company: {
        id: '',
        name: '',
        country: '',
        city: '',
        address: '',
        contract_number: '',
        contract_date: '',
        ogrnip: '',
        inn: '',
        company_type: '',
        bank_account: '',
        bank_name: '',
        bank_bik: '',
        bank_inn: '',
      },
      selectedCountry: {
        state: 'Россия',
        abbr: 'RU'
      },
      countries: [
        {state: 'Россия', abbr: 'RU'},
        {state: 'Казахстан', abbr: 'KZ'},
        {state: 'Белоруссия', abbr: 'BY'},
      ],
    };
  },
  computed: {
    nonEmptyRules() {
      return [
        v => !!v || 'Это поле нужно заполнить'
      ]
    },
    ogrnRules() {
      return [
        v => !!v || 'Это поле нужно заполнить',
        v => /^\d{10,15}$/.test(v) || 'ОГРН должен содержать от 10 до 15 цифр',
      ]
    },
    innRules() {
      return [
        v => !!v || 'Это поле нужно заполнить',
        v => (/^\d{10}$/.test(v) || /^\d{12}$/.test(v)) || 'ИНН должен содержать 10 или 12 цифр',
      ]
    },
    bankInnRules() {
      return [
        v => !v || (/^\d{10}$/.test(v) || /^\d{12}$/.test(v)) || 'ИНН банка должен содержать 10 или 12 цифр',
      ]
    },
    bikRules() {
      return [
        v => !v || /^\d{9}$/.test(v) || 'БИК должен содержать 9 цифр',
      ]
    },
  },
  created() {
    this.getCompanyInfo();
  },
  methods: {
    getCompanyInfo: async function () {
      const companyId = this.$route.params.id;
      if (!companyId) {
        return;
      }
      try {
        const response = await account.getCompany(companyId);
        this.company = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    saveAccountCompany: async function () {
      if (!this.validateCompanyInfo()) {
        return;
      }
      if (this.company.id) {
        await this.updateUserCompany();
        await this.$store.dispatch('auth/updateUserinfo');
        this.$store.dispatch("alertSuccess", "Информация о компании успешно сохранена");
        return this.$router.push({ name: 'CompanyView', params: { id: this.company.id } });
      }
      await this.createUserCompany();
      await this.$store.dispatch('auth/updateUserinfo');
      this.$store.dispatch("alertSuccess", "Информация о компании успешно сохранена");
      return this.$router.push({ name: 'CompanyView', params: { id: this.company.id } });
    },
    validateCompanyInfo: function () {
      if (this.company.name &&
        this.company.country &&
        this.company.city &&
        this.company.address &&
        this.company.ogrnip &&
        this.company.inn) {
        return true;
      }
      console.log('Пожалуйста, заполните все обязательные поля');
      this.$store.dispatch("alertError", "Пожалуйста, заполните все обязательные поля");
      return false;
    },
    updateUserCompany: async function () {
      try {
        const response = await account.changeAccountCompanyInfo(this.company);
        console.log('response', response);
        this.company = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    createUserCompany: async function () {
      const response = await account.createAccountCompanyInfo(this.company);
      this.company = response.data;
    },
  }
}
</script>

<style scoped>

</style>
